import { HeaderToggle, OrderItem } from '@components';
import { Container, Typography } from '@design-system';
import React from 'react';
import './EpiOrdersPage.scss';
import { EpiOrdersSkeleton } from './EpiOrdersSkeleton';
import { useEpiOrdersPageVM } from './useEpiOrdersPageVM';

export const EpiOrdersPage: React.FC = () => {
    const { currentOrders, pastOrders, isLoading, errorMessage } = useEpiOrdersPageVM();

    if (errorMessage) {
        return (
            <Container>
                <Typography intrinsic="p" color="red">
                    {errorMessage}
                </Typography>
            </Container>
        );
    }

    return (
        <div className="epi-orders-page">
            <HeaderToggle labels={['En cours', 'Passées']}>
                {isLoading || !currentOrders ? (
                    <EpiOrdersSkeleton />
                ) : (
                    <div>
                        {currentOrders.map((order) => (
                            <OrderItem key={order.id} {...order} type="epi" />
                        ))}
                    </div>
                )}

                {isLoading ? (
                    <EpiOrdersSkeleton />
                ) : (
                    <div>
                        {pastOrders.map((order) => (
                            <OrderItem key={order.id} {...order} isPast type="epi" />
                        ))}
                    </div>
                )}
            </HeaderToggle>
        </div>
    );
};
